import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_28: DocMigration = {
  maxSchemaVersion: "0.0.28",
  apply(json: any) {
    if (json.facades) {
      for (const facadeId in json.facades) {
        const facade = json.facades[facadeId];

        if (facade.suppressExteriorTrim !== "undefined") {
          if (facade.suppressExteriorTrim) {
            facade.cornerBoardBehavior = "REMOVE";
          }
          delete facade.suppressExteriorTrim;
        }

        if (facade.suppressWainscoting !== "undefined") {
          if (facade.suppressWainscoting) {
            facade.wainscotingBehavior = "REMOVE";
          }
          delete facade.suppressWainscoting;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_28;
